import { Card } from "@nfp-tracker/components";
import { AlertTriangle, ExternalLink } from "lucide-react";
import {
  HEALTH_DISCLAIMER_BODY,
  HEALTH_DISCLAIMER_FOOTER,
  HEALTH_DISCLAIMER_TITLE,
  HEALTH_REFERENCES,
} from "../constants/healthReferences";

interface HealthDisclaimerProps {
  showSources?: boolean;
  compact?: boolean;
}

const HealthDisclaimer = ({
  showSources = false,
  compact = false,
}: HealthDisclaimerProps) => {
  return (
    <Card className={compact ? "p-4 mt-0" : "p-5 mt-0"}>
      <div className="space-y-3">
        <div className="flex items-start gap-3">
          <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" />
          <div className="space-y-1">
            <h3 className="text-sm font-semibold">{HEALTH_DISCLAIMER_TITLE}</h3>
            <p className="text-sm text-muted-foreground">
              {HEALTH_DISCLAIMER_BODY}
            </p>
            <p className="text-sm text-muted-foreground">
              {HEALTH_DISCLAIMER_FOOTER}
            </p>
          </div>
        </div>

        {showSources && (
          <div className="space-y-2 border-t pt-3">
            <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              Educational reference links
            </p>
            <ul className="space-y-2">
              {HEALTH_REFERENCES.map((reference) => (
                <li key={reference.url} className="text-sm">
                  <a
                    href={reference.url}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-1 font-medium text-primary hover:underline"
                  >
                    {reference.label}
                    <ExternalLink className="h-3.5 w-3.5" />
                  </a>
                  <p className="text-muted-foreground">{reference.description}</p>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </Card>
  );
};

export default HealthDisclaimer;
